import { useEffect, useState } from 'react'
import { Autocomplete, Grid, TextField, Typography } from '@mui/material'
import { useApiData } from 'services/hook/useApiData'

const DynamicMultipleAutocomplete = ({ 
    setFieldValue, 
    initialValue, 
    fetchList, 
    fieldName, 
    labelKey = 'name', 
    valueKey = 'id', 
    multiple = true
}) => {
    const [value, setValue] = useState(initialValue ?? []);
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);

    const [customersData, , loading, loadData] = useApiData([], {}, (params, setData) => {
        fetchList(params)
            .then((res) => {
                const items = res?.data?.data ?? res?.data ?? [];
                setData(items);    
                setOptions(items);
            })
            .catch((err) => {
                setOptions([]);
            });
    }, false);

    useEffect(() => {
        loadData(true);
    }, []);

    useEffect(() => {
        if (initialValue) {
            setValue(initialValue);
        }
    }, [initialValue]);


    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
        
        if (newInputValue) {
            loadData({ search: newInputValue }); 
        }
    };

    const getLabel = (option) => {
        if (!option) return '';
        return option[labelKey] || option.name || '';
    };

    return (
        <Autocomplete 
            multiple={multiple}
            id="dynamic-autocomplete"
            className='custom_autocomplete'
            getOptionLabel={getLabel}
            filterOptions={(x) => x}
            options={options}
            loading={loading}
            value={value}
            isOptionEqualToValue={(option, value) => option[valueKey] === value[valueKey]}
            autoComplete
            includeInputInList
            filterSelectedOptions
            noOptionsText={loading ? "Loading..." : "No options found"}
            
            // FIX: Add proper z-index for the popper
            componentsProps={{
                popper: {
                    sx: {
                        zIndex: 1300, // Higher than your drawer/modal
                    }
                },
                paper: {
                    sx: {
                        backgroundColor: 'white',
                        boxShadow: '0px 5px 15px rgba(0,0,0,0.2)',
                    }
                }
            }}
            
            onChange={(event, newValue) => {
                console.log('Selection changed:', newValue);
                setValue(newValue);
                setFieldValue(fieldName, newValue);
            }}
            onOpen={() => {
                console.log('Dropdown opened');
                if (options.length === 0) {
                    loadData(true);
                }
            }}
            onInputChange={handleInputChange}
            renderInput={(params) => (
                <TextField 
                    {...params} 
                    placeholder="Select option" 
                    fullWidth 
                />
            )}
            renderOption={(props, option) => {
                const { key, ...rest } = props;
                return (
                    <li 
                        key={option[valueKey]} 
                        {...rest}
                        style={{
                            ...rest.style,
                            backgroundColor: 'white', // Force white background
                            padding: '8px 16px',
                        }}
                    >
                        <Grid container alignItems="center">
                            <Grid item sx={{ width: '100%', wordWrap: 'break-word' }}>
                                <Typography>
                                    {getLabel(option)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </li>
                );
            }}
        />
    )
}

export default DynamicMultipleAutocomplete